import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const AttendanceInsightsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'AttendanceInsightsLazy' */ './components/AttendanceInsights'
		)
);

export default (store) => {
	return {
		path: 'attendance-insights',
		element: <AsyncLoading component={<AttendanceInsightsLazy />} />,
	};
};
